var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-main"},[_c('div',{staticClass:"banner"},_vm._l((_vm.priceImgs.list),function(item,index){return _c('div',{key:index,staticClass:"priceImgs"},[(item.imageUrls)?_c('img',{attrs:{"src":_vm.BASE_URL + item.imageUrls}}):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }